<template>
  <md-dialog
    :md-active.sync="isShowModal"
    class="new w-800"
    :md-fullscreen="false"
    @md-opened="scroll('locked')"
    @md-closed="scroll('clear')"
  >
    <md-dialog-confirm
      class="new"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
      :md-active.sync="isDeleteConfirm"
      md-title=""
      md-content="<strong>削除してもよろしいですか？</strong>"
      md-confirm-text="はい"
      md-cancel-text="いいえ"
      @md-confirm="deleteItem"
    />

    <InvoiceEditModal
      :is-show-modal-active="isShowEditModalActive"
      :edit-invoice="invoice"
      @setIsShowModalActive="setIsShowEditModalActive"
    />

    <md-dialog-title>請求先お気に入り</md-dialog-title>

    <div class="px-3">
      <div class="text-right mx-2 mb-2">
        <b-button
          class="d-inline btn sp-fs-14"
          @click="isDeleteConfirm = true"
          :disabled="!selectedObj"
        >
          削除
        </b-button>
        <b-button
          class="d-inline btn btn-success sp-fs-14"
          @click="isShowEditModalActive = true"
          :disabled="!selectedObj"
        >
          編集
        </b-button>
      </div>

      <section id="order-invoice">
        <div v-if="isLoading" class="spinner my-5">
          <md-progress-spinner md-mode="indeterminate" />
        </div>
        <md-table
          v-else-if="$store.state.invoice.data.length"
          v-model="$store.state.invoice.data"
          class="black-svg h-300 checkbox"
          md-sort="id"
          md-sort-order="asc"
          md-card
          md-fixed-header
        >
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            @click="selected(item)"
            :class="getTableRowClass(item)"
          >
            <md-table-cell v-if="!isMobile" md-label="">
              <input
                type="radio"
                :id="item.id"
                :value="item.id"
                v-model="picked"
              />
            </md-table-cell>

            <md-table-cell md-label="会社名" md-sort-by="SKS_KAISYA">
              <span v-if="!isMobile">{{ item.SKS_KAISYA }}</span>
              <div v-else class="row">
                <p class="col-3 p-0 bold">会社名</p>
                <p class="col-9 p-0">{{ _omitText(item.SKS_KAISYA, 18) }}</p>
              </div>
            </md-table-cell>

            <md-table-cell md-label="住所" md-sort-by="SKS_TODO">
              <span v-if="!isMobile">{{ omitText(address(item), 45) }}</span>
              <div v-else class="row">
                <p class="col-3 p-0 bold">住所</p>
                <p class="col-9 p-0">{{ _omitText(address(item), 18) }}</p>
              </div>
            </md-table-cell>
          </md-table-row>
        </md-table>
        <div v-else class="text-center my-5 bold">該当データがありません。</div>
      </section>

      <md-dialog-actions>
        <md-button class="md-primary" @click="closed">閉じる</md-button>
        <md-button class="md-primary" @click="decision" :disabled="!invoice">
          決定
        </md-button>
      </md-dialog-actions>
    </div>
  </md-dialog>
</template>

<script>
import { validationMixin } from 'vuelidate'
import Mixin from '@/components/mixin/Mixin'
import _ from 'lodash'
import InvoiceEditModal from '@/components/order/invoice/InvoiceEditModal'

const MAX_TABLE_RECORD = 5
const ROW_HEIGHT = 50

export default {
  name: 'InvoiceListModal',
  components: { InvoiceEditModal },
  mixins: [validationMixin, Mixin],
  props: {
    isShowModalActive: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    /** モーダル表示フラグ **/
    isShowModal: false,
    /** 選択した請求先 **/
    invoice: null,
    /** 編集モーダル表示発火フラグ **/
    isShowEditModalActive: false,
    /** 削除確認モーダル表示フラグ **/
    isDeleteConfirm: false,
    /** 通信中フラグ **/
    isLoading: false,
  }),
  created: async function () {
    await this.getFavList()
  },
  methods: {
    /**
     * 請求先お気に入り一覧を取得する
     */
    getFavList() {
      return this.$store.dispatch('invoice/get').catch((err) => {
        this._alert(err.message, false)
      })
    },
    /**
     * リスト選択時の処理
     * @param  invoice item
     */
    selected(item) {
      this.invoice = item
      this.setTableRowClassAndName(item.id, this.invoiceList)
    },
    /**
     * リスト選択状態を解除
     */
    selectedReset() {
      this.invoice = null
      this.selectedTableInitial()
    },
    /**
     * 決定ボタン押下時: 選択した請求先データを親に通知する
     */
    decision() {
      const d = _.cloneDeep(this.invoice)
      delete d.id
      this.$emit('setInvoice', d)
      this.closed()
    },
    /**
     * モーダルを閉じる
     */
    closed() {
      this.isShowModal = false
    },
    /**
     * 住所を精製
     * @param  invoice item
     * @return string
     */
    address(item) {
      return `${item.SKS_TODO}${item.SKS_SHIKU_MEI}${item.SKS_JYUSYO1}`
    },
    /**
     * Setter 編集モーダル表示発火フラグ
     * @param {Boolean} val
     */
    setIsShowEditModalActive(val) {
      this.isShowEditModalActive = val
    },
    /**
     * 選択した請求先を削除する
     */
    async deleteItem() {
      this.isLoading = true
      await this.$store
        .dispatch('invoice/delete', this.invoice)
        .catch((err) => {
          this._alert(err.message, false)
        })
      this.isLoading = false
    },
  },
  computed: {
    invoiceList() {
      return this.$store.state.invoice.data
    },
  },
  watch: {
    /* モーダル表示発火 */
    isShowModalActive(val) {
      if (val) this.isShowModal = true
    },
    /* モーダル表示フラグ */
    isShowModal(val) {
      this.invoice = null
      this.$emit('setIsShowModalActive', this.isShowModal)
    },
    /* this.$storeの請求先リスト */
    invoiceList(val) {
      this.selectedReset()
      return this.$store.state.invoice.data
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../../assets/css/logico2'
.color-on
  background: $baseBlueColor
  color: #fff
.color-off
  background: #fff
  color: $baseBlackColor
</style>



// WEBPACK FOOTER //
// src/components/order/invoice/InvoiceListModal.vue